"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 3.751a8.25 8.25 0 1 0 0 16.499 8.25 8.25 0 1 0 0-16.499m2.583 8.75-3.712 2.428a.599.599 0 0 1-.927-.501V9.572a.598.598 0 0 1 .929-.499l-.002-.001 3.713 2.427a.6.6 0 0 1 .002 1.001z"
}), 'PlayCircleFilled');
//# sourceMappingURL=index.js.map